//2023-03-22 11:38:02 A component for ChatGPT chat only
import {
  ActionIcon,
  Box,
  Group,
  Input,
  Tooltip,
  Button,
  Stack,
  Text,
  Image,
  Modal,
  Alert,
  Center,
  useMantineTheme,
  LoadingOverlay,
  Loader,
} from "@mantine/core";
import React, { useState, useEffect, useRef } from "react";
import { showNotification } from "@mantine/notifications";
import { api } from "../services/api";
import ChatGptInput from "../components/ChatGptInput";
import ChatGptHeader from "../components/ChatGptHeader";

interface Props {
  setIsLogin: (isLogin: boolean) => void;
}

export const UserTypes = {
  LOCAL: "Local",
  CHATGPT: "ChatGPT",
};

export interface Message {
  user: {
    name: string;
    type: typeof UserTypes.LOCAL | typeof UserTypes.CHATGPT;
  };
  content: string;
  type: string;
}

function ChatGPT({ setIsLogin }: Props) {
  const [messages, setMessages] = useState<Message[]>([
    {
      user: { type: UserTypes.CHATGPT, name: "ChatGPT" },
      content:
        "Hi，欢迎来到ChatGPT聊天室，我是一个AI语言模型，欢迎随时找我聊天。",
      type: "text",
    },
  ]);

  const msgRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    msgRef?.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [messages.length]);

  console.log("messages", messages);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        background: "white",
      }}
    >
      <Box>
        <ChatGptHeader setIsLogin={setIsLogin} setMessages={setMessages} />
      </Box>
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {messages.map((message, index) => (
          <Box
            key={index}
            m='1rem'
            p='0.5rem 1rem'
            sx={(theme) => ({
              width: "max-content",
              maxWidth: "80%",
              borderRadius: "1rem",
              background:
                message.user.type === UserTypes.LOCAL
                  ? theme.colors.lime[4]
                  : theme.colors.gray[0], //yellow[1],
              alignSelf:
                message.user.type === UserTypes.LOCAL
                  ? "flex-end"
                  : "flex-start",
              //color: "white",
              whiteSpace: "pre-wrap",
            })}
          >
            <Text size='xs'>
              {message.user.name}
              {/* {dayjs(message.time).format("h:mm a")} */}
            </Text>
            {message.type === "text" ? <Text>{message.content}</Text> : null}
          </Box>
        ))}
        <Box ref={msgRef}></Box>
      </Box>
      <Box>
        <ChatGptInput messages={messages} setMessages={setMessages} />
      </Box>
    </Box>
  );
}

export default ChatGPT;
